import axios from 'lib/axios'
import { QualificationDetails } from '@homevest/types/rental-applications'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

export type RentalAppQualificationResponse = QualificationDetails | { error: string }

export const useRentalAppQualification = (
  rentalApplicationId: string,
  options: UseQueryOptions<RentalAppQualificationResponse> = {}
) => {
  return useQuery({
    queryKey: ['rentalApplicationQualification', rentalApplicationId],
    queryFn: async () => {
      const response = await axios.get(
        `/admin/rental_applications/${rentalApplicationId}/qualification`
      )
      return response.data
    },
    ...options
  })
}
